export default user => ({
  gender: (user.sex && user.sex.toLowerCase() === 'f') ? 'Kvinne' : 'Mann' || '',
  parti: (user.parties && user.parties.length > 0 && user.parties[0].id) || '',
  fnr: user.ssn || '',
  fornavn: user.givenName || '',
  etternavn: user.familyName || '',
  adresse: user.streetAddress || '',
  postnr: user.zipCode || '',
  poststed: user.city || '',
  tlfprivat: user.phone || '',
  arbeidssted: user.workplace || '',
  epost: user.email || '',
  bankkontonummer: user.bankAccount || '',
  generalInfo: user.generalInfo || '',
  // stilling: (user.party && user.party.role) || '',
});
